module.exports = __webpack_public_path__ + "static/media/heart.61e562cd.svg";